import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiAutocompleteOption } from './ui-autocomplete-field.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-autocomplete-field',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-autocomplete-field.component.html',
  styleUrl: './ui-autocomplete-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiAutocompleteFieldComponent {
  readonly label = input('');
  readonly value = input('');
  readonly placeholder = input('');
  readonly required = input(false);
  readonly readonly = input(false);
  readonly disabled = input(false);
  readonly loading = input(false);
  readonly error = input('');
  readonly hint = input('');
  readonly emptyMessage = input('No matches found.');
  readonly options = input<UiAutocompleteOption[]>([]);
  readonly valueChange = output<string>();
  readonly optionSelected = output<string>();
  isOpen = false;

  onValueChange(value: string): void {
    this.isOpen = true;
    this.valueChange.emit(value);
  }

  selectOption(value: string): void {
    this.isOpen = false;
    this.optionSelected.emit(value);
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    setTimeout(() => {
      this.isOpen = false;
    }, 120);
  }
}
